import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

/**
 * Reveal - wraps children in a div that fades up as it enters the viewport.
 * Use `delay` (0-4) to stagger reveals within the same section.
 */
export const Reveal = ({ children, delay = 0, as: Tag = 'div', className = '', ...rest }) => {
  const ref = useScrollReveal();
  const delayClass = delay > 0 ? `delay-${delay}` : '';
  return (
    <Tag ref={ref} className={`reveal ${delayClass} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
